export default {
  namespaced: true,
  state: {
    list : [],
    data : {}
  },
  mutations: {
    setTextassets(state, data){
      state.data=data;
    },
    addTextassets(state, data){
      const temp = JSON.parse(JSON.stringify(state.data));
      Object.keys(data).forEach((key)=>{
        temp[key]=data[key];
      });
      state.data=temp;
    }
  },
  actions: {},
  getters: {}
}